// 会话分页数
export const SESSION_PAGE_SIZE = 50;

// 移动端交互最大宽度
export const MOBILE_MAX_WIDTH = 760;

// 成功状态码
export const API_SUCCESS_CODE = 'XS000000';